const TransactionGetter = {
  transactions: (state) => state.transactions,
  paymentLogs: (state) => state.paymentLogs,
  providerLogs: (state) => state.providerLogs,
};

export default TransactionGetter;
